/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

const EditIcon = ({ height, width }) => (
	<svg xmlns="http://www.w3.org/2000/svg" height={height} width={width} viewBox="0 0 18.727 18.728">
		<path
			d="M18.367,3.51C17.847,2.98,15.745.878,15.215.362a1.226,1.226,0,0,0-1.733,0c-.123.108-.238.227-.357.347C9.661,4.171,1.166,12.688.368,13.465A1.1,1.1,0,0,0,0,14.339c.018,1.206.007,2.416.007,3.621a.947.947,0,0,0,.141.6l0,0s.007,0,.011.007.007.011.011.014l0,0a.947.947,0,0,0,.6.141c1.206,0,2.416-.011,3.621.007a1.1,1.1,0,0,0,.874-.372C6.04,17.559,18.024,5.6,18.024,5.6c.116-.116.235-.235.347-.357A1.229,1.229,0,0,0,18.367,3.51Zm-6.719.43c.018-.018.007,0,.007,0L12.824,5.1,3.267,14.653,2.1,13.486S8.8,6.785,11.647,3.94ZM1.216,17.509c0-1.029,0-2.029.007-3.029a.244.244,0,0,1,.025-.1l3.091,3.094a.244.244,0,0,1-.094.025C3.245,17.512,2.245,17.509,1.216,17.509ZM14.789,7.078c-2.845,2.849-9.546,9.546-9.546,9.546l-1.1-1.1L13.7,5.973l1.09,1.1S14.8,7.063,14.789,7.078Zm.928-1.036L12.684,3.008l1.7-1.679L17.4,4.341Z"
			transform="translate(0.001 -0.001)"
		/>
	</svg>
);

EditIcon.defaultProps = {
	height: '10px',
	width: '10px'
};

EditIcon.propTypes = {
	height: PropTypes.string,
	width: PropTypes.string
};
export default EditIcon;
